/**
 * The administrator's own invitation link (owner, 2026-10-29): the way in for
 * anyone the owner brings. Whoever joins by it has no referrer.
 */
import { useQuery } from "@tanstack/react-query";
import { Check, Copy, Link2 } from "lucide-react";
import { useState } from "react";

import { Button } from "@/design-system/Button";
import { readOwnInvitation } from "@/shared/api";

export function OwnInvitation(): React.JSX.Element {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const query = useQuery({
    queryKey: ["own-invitation"],
    enabled: open,
    retry: false,
    queryFn: async () => {
      const { data } = await readOwnInvitation({ cache: "no-store" });
      if (data === undefined) throw new Error("invitation unavailable");
      return data;
    },
  });
  if (!open) {
    return (
      <Button type="button" onClick={() => { setOpen(true); }}>
        <Link2 aria-hidden="true" className="size-4" />
        Моя ссылка-приглашение
      </Button>
    );
  }
  const link = query.data === undefined ? "" : `${window.location.origin}/join/${query.data.code}`;
  return (
    <span className="flex flex-wrap items-center gap-2" data-testid="own-invitation">
      {query.isError ? (
        <span role="alert" className="text-helper-sm text-status-warning">Ссылка недоступна: сначала создайте свой торговый счёт.</span>
      ) : query.data === undefined ? (
        <span role="status" className="text-helper-sm text-text-muted">Загружаю…</span>
      ) : (
        <>
          <code className="min-w-0 break-all rounded-row bg-background-base px-2 py-1 font-mono text-data-mono text-text-primary">{link}</code>
          <Button
            type="button"
            size="sm"
            onClick={() => { void navigator.clipboard.writeText(link).then(() => { setCopied(true); }); }}
          >
            {copied ? <Check aria-hidden="true" className="size-4" /> : <Copy aria-hidden="true" className="size-4" />}
            {copied ? "Скопировано" : "Скопировать"}
          </Button>
        </>
      )}
    </span>
  );
}
